import { MutationTree } from "vuex";
import { AlertState } from "./types";

export const mutations: MutationTree<AlertState> = {
  showAlert(state, payload) {
    state.content = payload.content;
    state.type = payload.type;
  }
};
